import { useCallback } from 'react'
import {
  MonthlyResourceBalanceVO,
  ResourceBalanceByTeamVO,
} from '../../../domain/value-object/ResourceBalanceVO'
import { useResourceBalanceRepository } from '../../../services/adaptors/resourceBalanceRepository'

type GetResourceBalance = {
  getResourceBalanceFromNowOn: () => Promise<ResourceBalanceByTeamVO[]>
  getMonthlyResourceBalance: (
    teamUuid: string | undefined
  ) => Promise<MonthlyResourceBalanceVO[]>
  getMonthlyTotalResourceBalance: () => Promise<MonthlyResourceBalanceVO[]>
}

export const useGetResourceBalance = (): GetResourceBalance => {
  const repository = useResourceBalanceRepository()

  const getResourceBalanceFromNowOn = useCallback(
    () => repository.getResourceBalanceFromNowOn(),
    [repository]
  )
  const getMonthlyResourceBalance = useCallback(
    (teamUuid: string | undefined) =>
      repository.getMonthlyResourceBalance(teamUuid),
    [repository]
  )
  const getMonthlyTotalResourceBalance = useCallback(
    () => repository.getMonthlyTotalResourceBalance(),
    [repository]
  )

  return {
    getResourceBalanceFromNowOn,
    getMonthlyResourceBalance,
    getMonthlyTotalResourceBalance,
  }
}
